import React from 'react';

interface EnterKeyHandlerProps {
  onSubmit: () => void;
  excludeTextarea?: boolean;
}

export const createEnterKeyHandler = ({
  onSubmit,
  excludeTextarea = true,
}: EnterKeyHandlerProps) => {
  return (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      if (excludeTextarea && e.target instanceof HTMLElement && e.target.tagName === 'TEXTAREA') {
        return;
      }
      if (!e.shiftKey) {
        e.preventDefault();
        onSubmit();
      }
    }
  };
};
